(function () {
'use strict';

class hyTableauInit {
  constructor(scope, tableauAllId, location) {
    this.scope = scope;
    this.tableauAllId = tableauAllId;
    this.location = location;
  }

  initSorting() {
    if (this.scope.useUrl) {
      this.scope.sortColumn = this.location.search().order;
      this.scope.sortDirection = this.location.search().direction;
    }
    if (!this.scope.sortColumn && this.scope.defaultSorting) {
      let tokens = this.scope.defaultSorting.split(' ');
      this.scope.sortColumn = tokens[0];
      this.scope.sortDirection = tokens[1];
    }
    if (!this.scope.sortColumn) {
      this.scope.sortColumn = this.scope.sortColumns[0].column;
    }
    if (!this.scope.sortDirection) {
      this.scope.sortDirection = 'ASC';
    }
  };
  
  initSortingColumns() {
    this.scope.sortColumns = this.scope.columns.filter(column => {
      let nonFilter = column.filterType === 'none';
      let isArray = column.type === 'array';
      return !nonFilter && !isArray;
    });
  };
    
  initFilters() {
    if (!this.scope.useUrl) return {};
    return this.scope.columns.filter(x => x.filterType !== 'none').reduce((acc, el) => {
      let value = this.location.search()[el.column];
      if (!value) {
        return acc;
      }
      acc[el.column] = el.lookup
        ? (el.lookup.multi
          // eslint-disable-next-line eqeqeq
          ? value.split(',').map(idValue => el.lookup.dictionary.find(x => x[el.lookup.idProperty] == idValue))
          // eslint-disable-next-line eqeqeq
          : el.lookup.dictionary.find(x => x[el.lookup.idProperty] == value))
        : value;
      return acc;
    }, {});
  };

  initColumns() {
    this.scope.columns.forEach(column => {
      if (column.type === 'boolean') {
        column.lookup = {
          idProperty: 'id',
          textProperty: 'text',
          dictionary: [
            { id: 0, text: 'nej' },
            { id: 1, text: 'Ja' },
          ]
        };
      }
      if (column.lookup && !column.lookup.multi) {
        let fAll = {  };
        fAll[column.lookup.idProperty] = this.tableauAllId;
        fAll[column.lookup.textProperty] = 'Alla';
        column.lookup.dictionary = [fAll].concat(column.lookup.dictionary);
      }
    });
  };

  initContextmenu() {
    if (!this.scope.fGetContextInfo()) {
      return;
    }
    const tableEl = document.getElementById('table'+this.scope.uuid);
    const contextMenuEl = document.getElementById('context-menu'+this.scope.uuid);

    const self = this;
    tableEl.addEventListener('contextmenu', function(e) {
        e.preventDefault();
        
        let cY = e.clientY;
        let cX = e.clientX;

        let rows = tableEl.rows;
        let start = self.scope.noFiltering ? 1 : 2;
        let hit = false;
        
        for (let rowIndex = start; rowIndex < rows.length; rowIndex++) {
          const rect = rows[rowIndex].getBoundingClientRect();
          if ((cY >= rect.top) && (cY <= rect.bottom)) {
            hit = true;
            let index = self.scope.noFiltering ? rowIndex - 1 : rowIndex - 2;
            self.scope.contextRow = self.scope.dataVM[index];
            self.scope.contextInfo = self.scope.fGetContextInfo()(self.scope.contextRow);
            self.scope.$apply();
          }
        }

        if (hit) {
          setTimeout(function () {
            contextMenuEl.style.left = (cX + 5) + 'px';
            contextMenuEl.style.top = (cY + 5) + 'px';
            contextMenuEl.style.display = 'block';
          }, 100);
        }
    });
    document.addEventListener('click', function() {
        contextMenuEl.style.display = 'none';
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.which === 27) {
        contextMenuEl.style.display = 'none';
      }
    });
    document.addEventListener('mousewheel', function() {
        contextMenuEl.style.display = 'none';
    });

    this.scope.contextMenuitems = [
      {
        title: 'Öppna i ny flik', 
        isVisible: (row, info) => (info && info.link),
        fn: (row, info) => { window.open(info.link, '_blank') } 
      },
      { 
        title: 'Dela',
        fn: (row, info) => {
          if (navigator.share) {
            let shareData = info.link
              ? {
                  title: info.title,
                  text: 'Förhandlarportalen för ditt livet',
                  url: info.link
              } : {
                  title: info.title,
                  text: info.title,
              };
            navigator.share(shareData);
          } else {
            navigator.clipboard.writeText(info.link);
            alert('Kopierad till urklipp');
          }
        }
      },
    ];
    if (this.scope.contextActions && this.scope.contextActions.length) {
      this.scope.contextMenuitems = this.scope.contextMenuitems.concat(this.scope.contextActions);
    }
  };


  maybeInit() {
    if (!(this.scope.fGetData && this.scope.fGetData()) || !this.scope.columns || this.scope.initReady) return false;
    if (this.scope.inMemory && !this.scope.inMemoryExcessiveLimit) return false;
    this.initColumns();
    this.initSortingColumns();
    this.initSorting();
    this.scope.offset = 0;
    this.scope.filters = this.scope.filtersOverride ? this.scope.filtersOverride : this.initFilters();
    this.scope.initReady = true;
    this.initContextmenu();
    return true;
  };
};

window.tableau = window.tableau || {};
window.tableau.Init = hyTableauInit;
})();